import client, { mock, isRealApiEnabled } from "./client";

// In-memory fallback for mock mode, keyed by product id.
const versionStore = {};

export function get(productId) {
  if (!productId) return mock(null);
  if (isRealApiEnabled())
    return client
      .get(`/v1/products/${encodeURIComponent(productId)}/versions`)
      .catch((err) => {
        if (err && err.status === 404) return null;
        throw err;
      });
  return mock(versionStore[productId] || null);
}

export function save(productId, { versions, currentVersionId } = {}) {
  if (!productId) return mock({ saved: false });
  const payload = {
    versions: Array.isArray(versions) ? versions : [],
    currentVersionId: currentVersionId || null,
  };
  if (isRealApiEnabled())
    return client.put(
      `/v1/products/${encodeURIComponent(productId)}/versions`,
      payload
    );
  // Mirror the backend: store a JSON-cloned snapshot with an updatedAt stamp.
  versionStore[productId] = {
    productId,
    ...JSON.parse(JSON.stringify(payload)),
    updatedAt: new Date().toISOString(),
  };
  return mock({ productId, saved: true });
}
